import { CoreBox } from '@youscience/core';

import ActionButton from '@components/ActionButton';

interface ContinueButtonProps {
  onContinue?: () => void;
  isDisabled?: boolean;
}

export const ContinueButton = ({ onContinue, isDisabled }: ContinueButtonProps) => {
  if (!onContinue) return null;

  return (
    <CoreBox sx={{ margin: '1.5rem 0', display: 'flex', justifyContent: 'flex-end' }}>
      <ActionButton onClick={onContinue} disabled={isDisabled} busyText="Saving" data-testid="continue-button">
        Continue to next section
      </ActionButton>
    </CoreBox>
  );
};
